import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { NavContext } from "../../state/NavContext";
import { SideContext } from "../../state/SideContext";
import { Form, Typography, Button, Row, Col, message } from "antd";
import axios from "axios";
import { UserContext } from "../../state/UserContext";

const { Title } = Typography;

const FormMovie = (props) => {
  let { id } = useParams();
  const history = useHistory();

  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);
  const { setSideIndex } = useContext(SideContext);
  const { user } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);

  const [movie, setMovie] = useState({});

  useEffect(() => {
    setSideIndex(props.sideIndex === "add-movie" ? "add-movie" : "all-movies");
    setActiveIndex("admin");
    setIsSideBarActive(true);
    setMovie({
      title: "",
      description: "",
      review: "",
      genre: "",
      rating: "",
      year: "",
      image_url: "",
      duration: "",
    });
  }, [props.sideIndex, setActiveIndex, setIsSideBarActive, setSideIndex]);

  useEffect(() => {
    if (props.sideIndex === "edit-movie" && id !== null) {
      // console.log(`loading data movie`);
      // console.log(`movie id: ${id}`);

      setIsLoading(true);

      axios
        .get(`https://backendexample.sanbersy.com/api/data-movie/${id}`)
        .then((res) => {
          // console.log(res.data);

          setMovie(res.data);

          // console.log(movie, "movie data setted");
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          message.error({ content: "Failed to load movie data" });
          console.log(err.response);
        });
    }
  }, []);

  const onFinish = () => {
    setIsLoading(true);
    const {
      title,
      description,
      review,
      year,
      duration,
      rating,
      image_url,
      genre,
    } = movie;

    if (props.sideIndex === "add-movie") {
      // console.log("add movie");

      // console.log(movie, "movie add");
      axios
        .post(
          "https://backendexample.sanbersy.com/api/data-movie",
          {
            title,
            description,
            review,
            year,
            duration,
            rating,
            image_url,
            genre,
          },
          {
            headers: { Authorization: "Bearer " + user.token },
          }
        )
        .then((res) => {
          setIsLoading(false);
          message.success({ content: "Success adding new movie" });
          history.push("/admin/all-movies");
        })
        .catch((err) => {
          setIsLoading(false);
          message.error({ content: "Failed adding movie" });
          console.log(err.response);
        });
    } else {
      // console.log("edit movie");

      axios
        .put(
          `https://backendexample.sanbersy.com/api/data-movie/${id}`,
          {
            title,
            description,
            review,
            year,
            duration,
            rating,
            image_url,
            genre,
          },
          {
            headers: { Authorization: "Bearer " + user.token },
          }
        )
        .then((res) => {
          setIsLoading(false);
          message.success({ content: "Success updating movie" });
          history.push("/admin/all-movies");
        })
        .catch((err) => {
          setIsLoading(false);
          message.error({ content: "Failed updating movie" });
          console.log(err.response);
        });
    }
  };

  const onFinishFailed = (values) => {};

  const handleChange = (e) => {
    setMovie({ ...movie, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          minHeight: 400,
          padding: 24,
          background: "white",
        }}
      >
        <Title level={2}>
          {props.sideIndex === "add-movie" ? "Add Movie" : "Edit Movie"}
        </Title>
        <Form
          name="basic"
          layout="vertical"
          wrapperCol={{ span: 24 }}
          value={{ remember: false }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Title"
            rules={[{ required: true, message: "Please input movie title!" }]}
          >
            <input
              className="ant-input"
              type="text"
              required
              placeholder="Input movie title"
              name="title"
              value={movie.title}
              onChange={handleChange}
            />
          </Form.Item>
          <Form.Item
            label="Description"
            rules={[
              { required: true, message: "Please input movie description!" },
            ]}
          >
            <textarea
              className="ant-input"
              type="text"
              required
              rows={4}
              placeholder="Input movie description"
              name="description"
              value={movie.description}
              onChange={handleChange}
            />
          </Form.Item>
          <Form.Item
            label="Review"
            rules={[{ required: true, message: "Please input movie review!" }]}
          >
            <textarea
              className="ant-input"
              type="text"
              required
              rows={4}
              placeholder="Input movie review"
              name="review"
              value={movie.review}
              onChange={handleChange}
            />
          </Form.Item>
          <Form.Item
            label="Genre"
            rules={[{ required: true, message: "Please input movie genre!" }]}
          >
            <input
              className="ant-input"
              type="text"
              required
              placeholder="Input movie genre"
              name="genre"
              value={movie.genre}
              onChange={handleChange}
            />
          </Form.Item>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label="Year"
                rules={[
                  {
                    required: true,
                  },
                  {
                    type: "number",
                    message: "input number only!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || (value >= 1980 && value <= 2021)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("year number range is between 1980 - 2021")
                      );
                    },
                  }),
                ]}
              >
                <div className="ant-input-number" style={{ width: "100%" }}>
                  <div className="ant-input-number-input-wrap">
                    <input
                      className="ant-input-number-input"
                      type="number"
                      required
                      placeholder="Input movie year"
                      name="year"
                      min="1980"
                      max="2021"
                      value={movie.year}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Duration"
                rules={[
                  {
                    required: true,
                  },
                  {
                    type: "number",
                    message: "input number only!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || value > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("duration must be greater than zero")
                      );
                    },
                  }),
                ]}
              >
                <div className="ant-input-number" style={{ width: "100%" }}>
                  <div className="ant-input-number-input-wrap">
                    <input
                      className="ant-input-number-input"
                      type="number"
                      required
                      placeholder="Input movie duration"
                      name="duration"
                      min="0"
                      value={movie.duration}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label="Rating"
                rules={[
                  {
                    required: true,
                  },
                  {
                    type: "number",
                    message: "input number only!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || (value >= 0 && value <= 10)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("year rating range is between 0 - 10")
                      );
                    },
                  }),
                ]}
              >
                <div className="ant-input-number" style={{ width: "100%" }}>
                  <div className="ant-input-number-input-wrap">
                    <input
                      className="ant-input-number-input"
                      type="number"
                      required
                      placeholder="Input movie rating"
                      name="rating"
                      min="0"
                      max="10"
                      value={movie.rating}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Image Url"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <input
                  className="ant-input"
                  type="text"
                  required
                  placeholder="Input movie image url"
                  name="image_url"
                  value={movie.image_url}
                  onChange={handleChange}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item wrapperCol={{ span: 24 }}>
            <Button type="primary" htmlType="submit" block loading={isLoading}>
              {props.sideIndex === "add-movie" ? "Add Movie" : "Update Movie"}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default FormMovie;
